import { ref } from "vue";
import { defineStore } from "pinia";
import useUtil from "@/composables/useUtil";

export const useGeneralStore = defineStore("general", () => {
  const loadingPage = ref(true);
  const imgLogo = ref("@/assets/img/logos/ventus-logo.png");
  const { baseURL } = useUtil();

  const initLoadingPage = () => {
    loadingPage.value = true;
  };

  const apiEndpoint = baseURL.value;

  const validateDecimal = (event) => {
    const { keyCode } = event;
    if (
      (keyCode >= 48 && keyCode <= 57) || // Números del teclado principal
      (keyCode >= 96 && keyCode <= 105) || // Números del teclado numérico
      keyCode == 8 || // Tecla de retroceso (backspace)
      keyCode == 9 || // Tecla de tabulación (tab)
      keyCode == 37 || // Tecla de flecha izquierda
      keyCode == 39 || // Tecla de flecha derecha
      keyCode == 46 || // Tecla de suprimir (delete)
      keyCode == 190 // Tecla de punto (.)
    ) {
      true;
    } else {
      event.preventDefault();
    }
  };

  return {
    loadingPage,
    initLoadingPage,
    validateDecimal,
    imgLogo,
    apiEndpoint,
  };
});
